var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Gift502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D32F2F",
    d: "M38,42H10c-1.1,0-2-0.9-2-2V20h32v20C40,41.1,39.1,42,38,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M42,20H6v-6c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2V20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F00",
    d: "M22 20H26V42H22zM32 6L28 6 22 12 26 12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M20 6L16 6 22 12 22 20 26 20 26 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Gift502);
export default __webpack_public_path__ + "static/media/icons8-gift-50-2.a46ec86647f18978be7aedd75bdc40f2.svg";
export { ForwardRef as ReactComponent };